export default __webpack_public_path__ + "static/media/factory__50.5d366852.jpg";